// extracted by mini-css-extract-plugin
export default {"root":"InputTag_root__3W2gX","addTag":"InputTag_addTag__mOppq","input":"InputTag_input__BVwb5"};